const Images = {
	appLogo: 'images/app-logo.svg',
	menuIcon: 'images/menuIcon.svg',
	closeBlue: 'images/closeBlue.svg',
	action: 'images/sidebar/action.svg',
	analytics: 'images/sidebar/analytics.svg',
	'callback-request': 'images/sidebar/callback.svg',
	campaign: 'images/sidebar/campaign.svg',
	workflow: 'images/sidebar/configuration.svg',
	'communication-templates': 'images/sidebar/action.svg',
	'invoice-slab-maintenance': 'images/sidebar/invoice-slab-maintenance.svg',
	'generate-invoice': 'images/sidebar/generate-invoice.svg',
	dashboard: 'images/sidebar/dashboard.svg',
	decision: 'images/sidebar/decision.svg',
	events: 'images/sidebar/events.svg',
	scope: 'images/sidebar/scope.svg',
	search: 'images/search.svg',
	delimiter_separated: 'images/separated.svg',
	excel: 'images/excel.svg',
	edit: 'images/edit.svg',
	delete: 'images/delete.svg',
	view: 'images/view.svg',
	downArrow: 'images/down-arrow.svg',
	deleteGrey: 'images/delete-grey.svg',
	deleteBlue: 'images/delete-blue.svg',
	addOperator: 'images/operator-add.svg',
	expand: 'images/expand.svg',
	copyClipboard: 'images/copy-clipboard.svg',
	upload: 'images/upload.svg',
	add: 'images/add.svg',
	download: 'images/download.svg',
	failed: 'images/failed.svg',
	success: 'images/success.svg',
	noun_sum: 'images/noun_sum.svg',
	manualUpload: 'images/upload-image.svg',
	xls: 'images/xls.png',
	xlsx: 'images/xls.png',
	csv: 'images/csv.svg',
	jpg: 'images/jpg.svg',
	png: 'images/png.svg',
	drag: 'images/drag.svg',
	txt: 'images/txt.png',
	close: 'images/close.svg',
	assignedTick: 'images/assigned-tick.svg',
	'payment-plan': 'images/sidebar/paymentPlan.svg',
	'transaction-table': 'images/sidebar/transaction.svg',
	'batch-upload': 'images/batch-upload.svg',
	'customer-file-upload': 'images/sidebar/fileUpload.svg',
	'batch-integration-maintenance': 'images/batch-integration.svg',
	warningPopup: 'images/warning-popup.svg',
	copyIcon: 'images/copy_icon.svg',
	loginLogo: 'images/logo.svg',
	tutorial: 'images/tutoriual.svg',
	chatbot: 'images/chatbot.svg',
	faq: 'images/faq.svg',
	contactus: 'images/contact-us.svg',
	congratulations: 'images/congratulations.svg',
	attachment: 'images/attachment.svg',
	email_verified: 'images/email-verified.svg',
	error_alert: 'images/login-error-alert.svg',
	faqbg: 'images/bg_image.png',
	call: 'images/call.svg',
	email: 'images/email.svg',
	location: 'images/location.svg',
	user: 'images/user.svg',
	help: 'images/help.svg',
	'team-members': 'images/team-member.svg',
	'my-profile': 'images/my-profile.svg',
	logout: 'images/logout.svg',
	roles: 'images/role.svg',
	'help-menu': 'images/help-menu.svg',
	'edit-blue': 'images/edit-blue.svg',
	filter: 'images/filter.svg',
	calandarBlue: 'images/calandar-blue.svg',
	calandar: 'images/calandar.svg',
	wallet: 'images/wallet.svg',
	eye: 'images/eye-black.svg',
	calandarV2: 'images/calenderV2.svg',
	noData: 'images/no-data.svg',
	arrow: 'images/arrow.svg',
	viewDark: 'images/view-dark.svg',
	trigger: 'images/trigger.svg',
	'user-management': 'images/sidebar/user-management.svg',
};

export default Images;
